"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.combineReducers = void 0;

var _backbone = _interopRequireDefault(require("backbone"));

var _redux = require("redux");

var _createExternalReducers = _interopRequireDefault(require("./createExternalReducers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Combine a set of regular Redux reducers, alongside models and collections, which will be automatically synced with
 * the store
 *
 * @param map
 * @param getStore
 * @return {{reducers: ((state: (any), action: AnyAction) => any), unbindExternals: *}}
 */
var combineReducers = function (map, getStore) {
  var reducers = {};
  var backboneEntities = {};
  Object.entries(map).forEach(function (_ref) {
    var name = _ref[0],
        entity = _ref[1];

    if (entity instanceof _backbone.default.Collection || entity instanceof _backbone.default.Model) {
      backboneEntities[name] = entity;
    } else {
      reducers[name] = entity;
    }
  });

  var _createExternalReduce = (0, _createExternalReducers.default)(backboneEntities, getStore),
      externalReducers = _createExternalReduce.externalReducers,
      unbindExternals = _createExternalReduce.unbindExternals;

  reducers = (0, _redux.combineReducers)(_extends({}, reducers, externalReducers));
  return {
    reducers: reducers,
    unbindExternals: unbindExternals
  };
};

exports.combineReducers = combineReducers;
var _default = combineReducers;
exports.default = _default;